<dashboardnav>
  <div class="main_content positioning">
    <div class="left_menu">
      <button (click)="filterPipelineRequest('Responded')" class="menu">Responded &nbsp;<span class="items">
          {{counts?.responded}} </span></button>
      <button (click)="filterPipelineRequest('UnResponded')" class="menu">Un-Responded &nbsp;<span
          class="items">{{counts?.unresponded}} </span></button>
      <button (click)="allPendingRequest()" class="menu">All Pending Requests <span class="items">{{counts?.all}}
        </span></button>
      <!-- <button class="menu">Message <span class="items">10</span></button> -->
    </div>
    <div class="right_side " *ngIf="pipelineRequests.length > 0">
      <div class="intray ">
        <div class="task_check-layout no-cursor">
          <div class="view_content ">
            <!-- <div class="task " *ngFor="let pipelineReq of pipelineRequests" (click)="selectPipeline(pipelineReq)">
              <span class="item">{{getPipelineName(pipelineReq.PipelineId)}}</span>
              <span class="item">
                <ul class="task_list " *ngFor="let activity of getPipelineReqActivities(pipelineReq.id)"
                  (click)="selectActivity(activity, pipelineReq, $event)">
                  <li class="task_name cursor">
                    {{activity.Name}}

                  </li>  
                </ul>
              </span>

            </div> -->
            <div class="task" *ngFor="let pipelineReq of pipelineRequests; let pIndex= index">
              <span class="item no-cursor">{{getPipelineName(pipelineReq.PipelineId)}} </span>

              <div class="task_info no-cursor">
                <div class="hold_info" *ngFor="let activity of pipelineReq.Activities; let aIndex=index">
                  <p class="task_name" (click)="selectActivity(activity, pipelineReq, $event)">{{activity.Name}} </p>
                  <p class="percentage"></p>
                  <div class="remark">
                    <p class="main_remark" (click)="getResponseHistory(pIndex,aIndex)">
                      <!-- {{getLastResponse(activity.id)}} -->
                      {{activity?.Responses[0]?.StakeholderResponse_Response ? activity?.Responses[0]?.StakeholderResponse_Response : activity?.Responses[0]?.Response}}
                    </p>

                    <span class="remark_history"
                      *ngIf="showResponseHistory && activityResponseHistory == activity?.Responses">
                      <em class="ti-close float-right" (click)="showResponseHistory=false"></em> 
                      <ul class="messages" *ngFor="let response of activityResponseHistory">
                        <li class="the_remark">
                          <span>
                            {{activity?.Responses[0]?.StakeholderResponse_Response ?
                         activity?.Responses[0]?.StakeholderResponse_Response : 
                        activity?.Responses[0]?.Response}}
                          </span>
                          <em class="ti-file float-right cursor"
                            (click)="pickFiles(response.StakeholderResponse_StakeholderResponseId ?response.StakeholderResponse_StakeholderResponseId : response.StakeholderResponseId)"></em> 
                          <!-- <mat-icon class="float-right">save</mat-icon> -->
                        </li>  
                        <!-- <li class="the_reply">Ok, Great Job</li>  
                        <li class="the_remark">
                          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sunt sapiente repudiandae mollitia?
                          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, nemo!
                        </li>  
                        <li class="the_reply">Ok, Great Job</li>   -->
                      </ul>
                    </span>
                  </div>
                </div>
                <!-- <div class="hold_info">
                  <p class="task_name">Develop and provide 12 survey maps per request</p>
                  <p class="percentage"></p>
                  <div class="remark">
                    <p class="main_remark">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Similique,
                      repellendus iste fugit distinctio incidunt</p>
                  </div>
                </div>
                <div class="hold_info">
                  <p class="task_name">Develop and provide 12 survey maps per request</p>
                  <p class="percentage"></p>
                  <div class="remark">
                    <p class="main_remark">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Similique,
                      repellendus iste fugit distinctio incidunt</p>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="new_report " *ngIf="selectedActivity" [formGroup]="responseForm">
          <div class="top">
            <h2 class="title">Response @{{getPipelineName(selectedPipelineRequest?.PipelineId)}}</h2>
            <em class="ti-close" (click)="closeResponseForm()"></em> 
          </div>

          <!-- <input type="date" name="" id="" class="default_input" /> -->

          <textarea name="" id="" cols="30" rows="10" class="default_input remark"
            placeholder="Click here to enter remark" formControlName="Response"></textarea>

          <!-- <div class="progress">
          <label for="">Progress</label>
          <input type="range" name="" id="" />
        </div> -->

          <div class="final">
            <input #file type="file" multiple hidden (change)="pickFiles($event)" />
            <em class="ti-clip" (click)="pickFiles()"></em> 
            <div class="contain">
              <span class="notify">
                <input type="checkbox" name="" id="" /> Notify </span>
              <button class="default_primary-button" (click)="saveResponse()">Send</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <ng-template *ngIf="pipelineRequests.length > 0">
      <h3>No Pipeline Renewal Request could be loaded at the moment!</h3>
    </ng-template>
  </div>
  <cradua-list-spinner *ngIf="isLoadingPipelineDetails$ | async"></cradua-list-spinner>
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
</dashboardnav>